export const TYPE_FILES = {
    EXCEL: 'EXCEL',
    WORD: 'WORD',
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    COMPRESS: 'COMPRESS',
    PDF: 'PDF',
    POWERPOINT: 'POWERPOINT',
    SOUND: 'SOUND',
    EXE: 'EXE',
    DEB: 'DEB',
    DMG: 'DMG'
};

export const TYPE_FILES_EVENT = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
};